<script setup>
  import { computed } from "vue";

  const props = defineProps({
    label: {
      type: String,
      default: "Writing...",
    },
    size: {
      type: String,
      default: "default",
      validator: (v) => ["sm", "default"].includes(v),
    },
  });

  const containerClass = computed(() =>
    props.size === "sm" ? "flex items-center gap-1.5" : "flex items-center gap-2",
  );

  const labelClass = computed(() =>
    props.size === "sm"
      ? "text-3xs font-medium text-primary"
      : "text-xs font-medium text-primary",
  );
</script>

<template>
  <div :class="containerClass">
    <span class="relative flex h-2 w-2">
      <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
      <span class="relative inline-flex rounded-full h-2 w-2 bg-primary" />
    </span>
    <span :class="labelClass">{{ label }}</span>
  </div>
</template>
